import useGetLatestReview from "@/hooks/useGetLatestReview";
import { Status } from "@/types";
import { ReactNode, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

type Props = {
  children: ReactNode;
};

export default function ReviewStatusGuard({ children }: Props) {
  const { data, isLoading } = useGetLatestReview();
  const placeRef = localStorage.getItem("placeRef");
  const navigate = useNavigate();

  const { t } = useTranslation();

  useEffect(() => {
    if (
      !isLoading &&
      placeRef &&
      data?.restaurant.id === parseInt(placeRef) &&
      data.status === Status.Rejected
    ) {
      navigate("/review-rejected", { replace: true });
    }
  }, [data, isLoading, placeRef, navigate]);

  // Don't render children until fetch completes
  if (isLoading) {
    return (
      <div className="fixed inset-0 flex h-svh flex-col items-center justify-center gap-6">
        <div className="h-16 w-16 animate-spin rounded-full border-4 border-medium-gray border-t-primary"></div>
        <p className="text-center text-lg text-brand-gray">{t("common.loading")}...</p>
      </div>
    );
  }

  return <>{children}</>;
}
